import dayjs from 'dayjs'
import type { filtersType } from '../../../components/v2/filters/interfaces'

export const filtersList = (currentFilters, availableFilters): filtersType[] => {
  return [
    {
      name: 'date_work_completion',
      label: 'Дата исполнения работ',
      type: 'dates',
      value: currentFilters?.date_work_completion,
      skipReset: currentFilters?.date_work_completion
        ? dayjs(currentFilters?.date_work_completion.split('-')[0]).isSame(
            dayjs(currentFilters?.date_work_completion.split('-')[1]),
          )
        : false,
    },
    {
      name: 'stage',
      label: 'Стадия',
      type: 'select_multiple',
      value: currentFilters?.stage?.split(',').filter(Boolean),
      options: {
        enum: availableFilters?.stage || [],
      },
    },
  ]
}
